import { css, media, styled } from '@nx-kit/styling';
import Button from 'components/atoms/Button/Button';

export const ButtonStyled = styled(Button)`
  width: max-content !important;
  min-width: max-content !important;
  max-width: none !important;
  display: inline-flex;
  flex: 0 0 auto;
  position: relative !important;
  z-index: auto !important;
  height: auto !important;
  min-height: auto !important;
  white-space: nowrap !important;
  word-break: keep-all !important;
  overflow-wrap: normal !important;
  justify-content: space-between;
  cursor: pointer;
  align-self: flex-start;

  &&& {
    outline-width: 0 !important;
    box-shadow: none !important;
  }

  &:hover,
  &:focus,
  &:active {
    outline-width: 0 !important;
    box-shadow: none !important;
    transform: none !important;
  }

  & > span {
    white-space: nowrap !important;
    word-break: keep-all !important;
    overflow-wrap: normal !important;
  }

  ${media('md')} {
    width: max-content !important;
    min-width: max-content !important;
    max-width: none !important;
  }
`;
export const PdfContentStyled = styled.div`
  display: none;
`;

export const pdfCss = css`
  @font-face {
    font-family: DIN;
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
    src: url('/fonts/normal/FFDINRegular.woff2') format('woff2'),
      url('/fonts/normal/FFDINRegular.woff') format('woff');
  }
  @font-face {
    font-family: DIN;
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
    src: url('/fonts/medium/FFDINMedium.woff2') format('woff2'),
      url('/fonts/medium/FFDINMedium.woff') format('woff');
  }
  @font-face {
    font-family: DIN;
    font-weight: bold;
    font-style: normal;
    font-display: fallback;
    src: url('/fonts/bold/FFDINBold.woff2') format('woff2'),
      url('/fonts/bold/FFDINBold.woff') format('woff');
  }

  @page {
    size: A4;
    margin: 0;
  }

  body {
    font-family: DIN, Helvetica, Arial, sans-serif;
    padding: 12mm;
    margin: 0;
    position: relative;
    background: #f3f3f3;
  }

  .pdf-page {
    width: 210mm;
    min-height: 297mm;
    padding: 12mm 10mm 20mm;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0 0 8mm rgba(0, 0, 0, 0.08);
    position: relative;
    margin: 0 auto;
    overflow: hidden;
  }

  .pdf-page + .pdf-page {
    margin-top: 10mm;
  }

  .logo-wrapper {
    position: absolute;
    top: 8mm;
    right: 10mm;
    display: flex;
    justify-content: flex-end;
    margin: 0;
  }

  .logo-wrapper svg,
  .logo-wrapper img {
    width: 38mm;
    height: auto;
  }

  h1 {
    display: block;
    width: 100%;
    font-size: 6mm;
    padding-bottom: 1mm;
    text-align: left;
    margin: 0 0 2mm 0;
    padding-right: 60mm;
  }

  table {
    table-layout: fixed;
    width: 100%;
    margin-bottom: 2mm;
    margin-left: 0;
    margin-right: 0;
    font-size: 3.6mm;
    line-height: 1.3;
  }

  th,
  td {
    text-align: left;
    padding: 0.3mm 1mm;
  }

  thead th {
    padding-bottom: 1mm;
  }

  tbody tr + tr td {
    padding-top: 0.2mm;
  }

  table,
  thead,
  tbody,
  tr,
  td,
  th {
    page-break-inside: avoid;
  }

  .pdf-page-break {
    page-break-after: always;
    break-after: page;
  }

  .pdf-footer {
    position: relative;
    margin-top: 4mm;
    font-size: 2.6mm;
    line-height: 1.25;
  }

  .pdf-footer h3,
  .pdf-footer h4,
  .pdf-footer h5,
  .pdf-footer p {
    margin: 0;
    padding: 0;
    line-height: 1.25;
  }

  .pdf-footer strong,
  .pdf-footer b {
    display: block;
    margin-top: 1mm;
  }

  @media print {
    body {
      font-family: DIN, Helvetica, Arial, sans-serif;
      padding: 0;
      margin: 0;
      position: relative;
      background: #ffffff;
      display: block;
    }

    .pdf-page {
      width: auto;
      min-height: auto;
      padding: 12mm 10mm 12mm;
      box-shadow: none;
    }

    .logo-wrapper {
      position: absolute;
      top: 8mm;
      right: 10mm;
      display: flex;
      justify-content: flex-end;
      margin: 0;
    }

    .logo-wrapper svg,
    .logo-wrapper img {
      width: 38mm;
      height: auto;
    }

    h1 {
      display: block;
      width: 100%;
      font-size: 6mm;
      padding-bottom: 1mm;
      text-align: left;
      margin: 0 0 2mm 0;
      padding-right: 60mm;
    }

    table {
      table-layout: fixed;
      width: 100%;
      margin-bottom: 2mm;
      margin-left: 0;
      margin-right: 0;
      font-size: 3.6mm;
      line-height: 1.3;
    }

    th,
    td {
      text-align: left;
      padding: 0.3mm 1mm;
    }

    thead th {
      padding-bottom: 1mm;
    }

    tbody tr + tr td {
      padding-top: 0.2mm;
    }

    table,
    thead,
    tbody,
    tr,
    td,
    th {
      page-break-inside: avoid;
    }

    th:first-of-type,
    th:last-of-type td:first-of-type,
    td:last-of-type {
      width: 40%;
    }

    th:nth-of-type(2),
    td:nth-of-type(2) {
      width: 20%;
    }

    .gastro-row {
      padding-bottom: 10mm;
    }

    i {
      font-style: italic;
    }

    .pdf-footer {
      font-size: 2.6mm;
      line-height: 1.25;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 6mm;
      padding: 0 14mm;
    }

    .pdf-footer h3,
    .pdf-footer h4,
    .pdf-footer h5,
    .pdf-footer p {
      margin: 0;
      padding: 0;
      line-height: 1.25;
    }

    .pdf-footer strong,
    .pdf-footer b {
      display: block;
      margin-top: 1mm;
    }

    .pdf-footer img {
      max-width: 100%;
    }
  }
`;
